import type { CreateSeriesInput, UpdateSeriesInput } from '@financiar/shared';
import { apiClient } from '../../api/client';
import type { Series, SeriesWrite } from '../../api/types';

/** `GET /firms/:firmId/series` — unpaginated by design (a firm realistically
 * has a handful of series, never a list worth paging through). */
export async function fetchSeries(firmaId: string): Promise<Series[]> {
  const { data } = await apiClient.get<Series[]>(`/firms/${firmaId}/series`);
  return data;
}

export async function createSeries(firmaId: string, input: CreateSeriesInput): Promise<SeriesWrite> {
  const { data } = await apiClient.post<SeriesWrite>(`/firms/${firmaId}/series`, input);
  return data;
}

export async function updateSeries(id: string, input: UpdateSeriesInput): Promise<SeriesWrite> {
  const { data } = await apiClient.patch<SeriesWrite>(`/series/${id}`, input);
  return data;
}

export async function deleteSeries(id: string): Promise<void> {
  await apiClient.delete(`/series/${id}`);
}
